import { WithClassname } from '../../types';
import { CloseCircleOutlined, EditOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import collect from 'collect.js';
import classnames from 'classnames';
import { Popconfirm } from 'antd';
import React from 'react';
import useOrderBasket from '../../hooks/context/useOrderBasket';
import useHelpers from '../../hooks/utility/useHelpers';
import { Client } from '../../types/basket';

type Props = {
  data: Client.OrderLineItem[];
  editable?: boolean;
} & WithClassname;

export default function OrderItemsList({ data, editable, className }: Props) {
  const { openLineItemModal, decrementItem, incrementItem, removeItem } = useOrderBasket();

  const { formatCurrency } = useHelpers();

  return (
    <table className={classnames('h-fit', className)}>
      <tbody>
        <tr>
          <td className="py-xs">Item</td>
          <td className="py-xs text-center">Quantity</td>
          <td className="py-xs text-right">Price</td>
        </tr>
        {data.map((item, index) => (
          <tr key={`line-item-${index}`} className="border-t">
            <td className="py-xs">
              <button
                onClick={() => (editable ? openLineItemModal(item, index) : null)}
                className={classnames('contents', { 'cursor-default': !editable })}
              >
                {editable && <EditOutlined className="mr-xs" />}
                {item.product.name}
              </button>
              {item.modifiers.length > 0 && (
                <p className="text-xs">{collect(item.modifiers).implode('modifier.name', ', ')}</p>
              )}
              {Boolean(item.note) && (
                <p
                  className={classnames('text-xs italic', {
                    'mt-xs': item.modifiers.length > 0,
                  })}
                >
                  Note: {item.note}
                </p>
              )}
            </td>
            <td className="py-xs">
              <div className="w-full flex">
                <div className="flex justify-between m-auto">
                  <div className={classnames('flex gap-sm rounded-xl', { border: editable })}>
                    {editable && (
                      <button className="my-auto p-xs" onClick={() => decrementItem(index)}>
                        <MinusOutlined />
                      </button>
                    )}
                    <p className="my-auto">{item.quantity}</p>
                    {editable && (
                      <button className="my-auto p-xs" onClick={() => incrementItem(index)}>
                        <PlusOutlined />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </td>
            <td className="text-right py-xs">
              {formatCurrency(item.package_price)}
              {editable && (
                <Popconfirm
                  title={`Remove ${item.product.name}`}
                  description="Are you sure?"
                  onConfirm={() => removeItem(index)}
                  okButtonProps={{ danger: true }}
                  okText="Yes"
                  cancelText="No"
                >
                  <button className="ml-xs">
                    <CloseCircleOutlined />
                  </button>
                </Popconfirm>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
